import { useState, createContext, useCallback } from 'react';
import {
  CssBaseline
} from '@material-ui/core';
import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { BrowserRouter, Route } from 'react-router-dom'

import Notifications from 'UI/Components/Notifications/Notifications';
import Navigation from 'UI/Blocks/Navigation/Navigation';
import Footer from 'UI/Blocks/Footer/Footer';
import MainScreen from 'UI/Screens/Main/MainScreen';
import DriverHireScreen from 'UI/Screens/Services/DriverHireScreen';
import VehicleHireScreen from 'UI/Screens/Services/VehicleHireScreen';
import ScrollHandler from 'UI/Components/ScrollHandler/ScrollHandler';
import PrivacyPolicy from 'UI/Screens/PrivacyPolicy/PrivacyPolicy';
import DeleteAccount from 'UI/Screens/DeleteAccount/DeleteAccount';
import theme from 'Styles/theme.json';
import 'main.scss';
import { QueryClient, QueryClientProvider } from "react-query";


const muiTheme = createMuiTheme(theme);

export const NotificationContext = createContext({});

const App = () => {
  const queryClient = new QueryClient()
  const [notifications, setNotifications] = useState([]);
  const addNotification = useCallback((text, severity) => {
    setNotifications([
      ...notifications,
      {
        text,
        severity,
      }
    ]);
    setTimeout(() => {
      const newNotifications = [...notifications];
      newNotifications.shift();
      setNotifications(newNotifications);
    }, 5000);
  }, [notifications]);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={muiTheme}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <NotificationContext.Provider value={addNotification}>
            <BrowserRouter>
              <Navigation />

              <Route exact path='/' render={() => <MainScreen />} />
              <Route path='/vehicle-hire' component={() => <VehicleHireScreen />} />
              <Route path='/driver-hire' component={() => <DriverHireScreen />} />
              <Route path='/privacy-policy' component={() => <PrivacyPolicy />} />
              <Route path='/delete-account' component={() => <DeleteAccount />} />

              <Footer />
              <ScrollHandler />
            </BrowserRouter>
            {notifications && <Notifications notifications={notifications} />}
          </NotificationContext.Provider>
        </MuiPickersUtilsProvider>

        <CssBaseline />
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
